import { useState, useEffect } from 'react'

// Module-level start time ensures all consumers share the same countdown
const startTime = Date.now()
const DURATION = 15 * 60 * 1000 // 15 minutes in ms

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const elapsed = Date.now() - startTime
    return Math.max(0, Math.floor((DURATION - elapsed) / 1000))
  })

  useEffect(() => {
    if (timeLeft <= 0) return
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime
      const remaining = Math.max(0, Math.floor((DURATION - elapsed) / 1000))
      setTimeLeft(remaining)
      if (remaining <= 0) clearInterval(interval)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

  return { timeLeft, minutes, seconds, formatted }
}
